import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';

import { RtUICommonModule } from '../common/common.module';
import { RtUIFormsModule } from '../forms/forms.module';
import { DataTableGeometryComponent } from './data-table-geometry/data-table-geometry.component';
import { DataTableOptionsButtonComponent } from './data-table-options-button/data-table-options-button.component';
import { DataTableRowComponent } from './data-table-row/data-table-row.component';
import { DataTableComponent } from './data-table/data-table.component';
import { DataTableColumnResizeDirective } from './directives/data-table-column-resize.directive';

@NgModule({
  imports: [RtUICommonModule, RtUIFormsModule, DragDropModule],
  declarations: [
    DataTableComponent,
    DataTableRowComponent,
    DataTableColumnResizeDirective,
    DataTableGeometryComponent,
    DataTableOptionsButtonComponent,
  ],
  exports: [DataTableComponent, DataTableOptionsButtonComponent],
})
export class RtUIDataTableModule {}

export { DataTableOptionsButtonComponent } from './data-table-options-button/data-table-options-button.component';
export { DataTableComponent } from './data-table/data-table.component';
